import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import authorrStyle from './AuthorRagistrationPage.module.css'
import AuthorHeader from '../../components/AuthorHeader/AuthorHeader'
//import AuthorLoginPage from './AuthorLoginPage'
import Login from '../../../components/Login.jsx';
import { useMediaQuery } from 'react-responsive';
import AuthormobilStepOne from './AuthormobilStepOne';
import AuthormobilStepTwo from './AuthormobilStepTwo';
import AuthormobilStepThree from './AuthormobilStepThree';
import Swal from "sweetalert2";
import axios from "axios";
require('typeface-poppins')

export default function AuthorRagistrationPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "", // Add confirmPassword field to state
  });
  const navigate = useNavigate();

  /*const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };*/

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      setFormData({
        ...formData,
        phone: formatPhoneNumber(value),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const formatPhoneNumber = (value) => {
    // Remove non-digits
    const cleaned = value.replace(/\D/g, "");

    // Limit to 10 digits
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    let formatted = match[1];
    if (match[2]) formatted += "-" + match[2];
    if (match[3]) formatted += "-" + match[3];

    return formatted;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if password and confirmPassword match
    if (formData.password !== formData.confirmPassword) {
      Swal.fire({
        title: "Error!",
        text: "Passwords do not match.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return; // Prevent form submission if passwords do not match
    }

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_author.php`, formData);
      if (response.data.message) {
        const userId = response.data.user_id;

        Swal.fire({
          title: "Registration Successful!",
          text: "Redirecting to your profile...",
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Redirect after pop-up
          navigate(`/AuthorEditPage/${userId}`);
        });
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      let errorMessage = "Something went wrong. Please try again.";

      // ✅ Read backend error message
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }

      Swal.fire({
        title: "Registration Failed!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });

      /*console.error("Error submitting form", error);
      alert("Error submitting form"); */
    }
  };

  // Define state for the current step
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Define total steps in the process
  const totalSteps = 3;

  // Handle the next step
  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle the form submission
  const steppersubmit = () => {
    // Logic for form submission can go here
    setIsSubmitted(true);
    // console.log('Form submitted');
  };

  return (
    <>
      <AuthorHeader />
      {isMobile ? (
        <div className={authorrStyle.authormobilRegiscation}>
          <div className='container'>
            <div className='row'>
              <div className='col-xl-12'>
                <div className={authorrStyle.authorstepperWrapper}>

                  <div className={authorrStyle.authorstepperContent}>
                    {currentStep === 1 && <AuthormobilStepOne />}
                    {currentStep === 2 && <AuthormobilStepTwo />}
                    {currentStep === 3 && <AuthormobilStepThree />}
                  </div>
                  <div className={`${authorrStyle.authorstepperFooter} mb-5`}>
                    {/* <button onClick={prevStep} disabled={currentStep === 1}> Back </button> */}
                    {currentStep === totalSteps ? (
                      <button className={`${authorrStyle.authorsubmitStepper} btn btn-warning w-100`} onClick={steppersubmit} disabled={isSubmitted}>
                        {isSubmitted ? 'Submitted' : 'Submit'}
                      </button>
                    ) : (
                      <button className={`${authorrStyle.authornextStepper} btn btn-warning w-100`} onClick={nextStep} disabled={currentStep === totalSteps}>
                        Next
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={authorrStyle.authorregistrationpage} style={{ minHeight: '800px' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8 col-xxl-8">
                <div className={authorrStyle.authorregistrationWrap}>
                  <h2>Author Registration Form</h2>
                  <form onSubmit={handleSubmit}>
                    <div className={authorrStyle.authorregistrationFormpart}>
                      <div className="row">
                        <div className="col mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}>First Name</label>
                          <input type="text" className={`${authorrStyle.authorragistrationFormcontrol} form-control`} placeholder="" name="fname" value={formData.fname} onChange={handleChange} required />
                        </div>
                        <div className="col mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}>Last Name</label>
                          <input type="text" className={`${authorrStyle.authorragistrationFormcontrol} form-control`} placeholder="" name="lname" value={formData.lname} onChange={handleChange} required />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}>Email Address</label>
                          <input type="email" className={`${authorrStyle.authorragistrationFormcontrol} form-control`} placeholder="" name="email" value={formData.email} onChange={handleChange} required />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}>Phone:</label>
                          <input type="tel" className={`${authorrStyle.authorragistrationFormcontrol} form-control`} placeholder="XXX-XXX-XXXX" name="phone" value={formData.phone} onChange={handleChange} maxLength={12} required />
                        </div>
                      </div>
                      <h5>Password</h5>
                      <div className="row">
                        <div className="mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}> Choose your password </label>
                          <div className={authorrStyle.arpasswordWrapper}>
                            <input type={isPasswordVisible ? "text" : "password"} className={`${authorrStyle.authorragistrationFormcontrol} form-control`} value={formData.password} onChange={handleChange} name="password" required />
                            <div className={authorrStyle.artoggleButton} onClick={togglePasswordVisibility}>
                              {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3">
                          <label className={`${authorrStyle.authorragistrationlabel} form-label`}> Confirm your password </label>
                          <div className={authorrStyle.arpasswordWrapper}>
                            <input type={isCPasswordVisible ? "text" : "password"} className={`${authorrStyle.authorragistrationFormcontrol} form-control`} value={formData.confirmPassword} onChange={handleChange} name="confirmPassword" required />
                            <div className={authorrStyle.artoggleButtonOne} onClick={toggleCPasswordVisibility}>
                              {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col text-center">
                          <h6 className={authorrStyle.havenotText}> Have an account? <Link to="/general-login" element={<Login />}>Sign in</Link> </h6>
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-lg-7">
                          <div className={authorrStyle.artermbox}>
                            <h6>Term and Conditions</h6>
                            <div className={`${authorrStyle.arterminner} mb-4`}>
                              <ul>
                                <li><span>A.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>B.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>C.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>D.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>E.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>F.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>G.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>H.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                                <li><span>I.</span> The ordering process will include an inscription line for each title puLorem ipsum dolor sit amet,
                                  consectetur adipiscing elit. Integer nec odio. Praesent libero.
                                </li>
                                <li><span>J.</span> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. </li>
                              </ul>
                            </div>
                          </div>
                          <div className="form-check mb-5">
                            <input type="checkbox" className="form-check-input" />
                            <label className={`${authorrStyle.authorragistrationlabel} form-check-label`}>Agree to terms and conditions</label>
                          </div>
                          <div className="text-center">
                            <button className={`${authorrStyle.arsubmitButton} btn btn-primary`} type="submit">SUBMIT</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
